import {
  ApproveSalaryDataTypes,
  HistoryApproveSalaryData,
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getApproveSalaryDetailService = async (
  id: string,
  params?: BaseFilterParams & {
    _getApproved?: 1 | 0,
  },
): Promise<ApproveSalaryDataTypes> => {
  const res = await axiosInstance.get(`payroll-periods/approve-detail/${id}`, { params });
  return res.data.data;
};

export const getAllApproveDepartmentSalaryService = async (
  params?: BaseFilterParams & {
    _exceptPayrollPeriodStatusApprove?: string,
    _payrollPeriodStatus?: string,
    _getApproved?: 1 | 0,
  },
): Promise<APIPaginationResponse<ApproveSalaryDataTypes[]>> => {
  const res = await axiosInstance.get('payroll-periods/approve-department-list', { params });
  return res.data;
};

export const getApproveDepartmentSalaryDetailService = async (
  id: string,
  params?: BaseFilterParams,
): Promise<ApproveSalaryDataTypes> => {
  const res = await axiosInstance.get(`payroll-periods/approve-department-detail/${id}`, { params });
  return res.data.data;
};

export const getAllHistoryApproveSalaryService = async (
  params?: BaseFilterParams
): Promise<APIPaginationResponse<HistoryApproveSalaryData[]>> => {
  const res = await axiosInstance.get('payroll-period-approve-logs', { params });
  return res.data;
};

export const getHistoryApproveSalaryDetailService = async (
  id: string,
): Promise<ApproveSalaryDataTypes> => {
  const res = await axiosInstance.get(`payroll-period-approve-logs/${id}`);
  return res.data.data;
};
